
// components/helpers/validateUserSession.js


import Parse from '../../parseConfig';
import { forceLogout } from './authHelpers';


export const validateUserSession = async (onInvalidSession) => {

  const currentUser = Parse.User.current();

  if (!currentUser) {

    //console.log('No user session found.');

    await forceLogout({ redirectToWelcome: false });

    if (onInvalidSession) onInvalidSession();

    return false;
  }

  try {

    await currentUser.fetch(); // Check with server
    return true;
  }
  catch (error) {

    //console.log('Invalid session token or user deleted.');

    await forceLogout({ redirectToWelcome: false });

    if (onInvalidSession) onInvalidSession();

    return false;
  }
};


